var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99987 1.51677C5.47991 0.527841 7.21997 0 9 0C11.387 0 13.6761 0.948211 15.364 2.63604C17.0518 4.32387 18 6.61305 18 9C18 10.78 17.4722 12.5201 16.4832 14.0001C15.4943 15.4802 14.0887 16.6337 12.4442 17.3149C10.7996 17.9961 8.99002 18.1743 7.24419 17.8271C5.49836 17.4798 3.89472 16.6226 2.63604 15.364C1.37737 14.1053 0.520204 12.5016 0.172936 10.7558C-0.17433 9.00998 0.0038996 7.20038 0.685088 5.55585C1.36628 3.91131 2.51983 2.50571 3.99987 1.51677ZM4.55544 15.6518C5.87104 16.5308 7.41775 17 9 17C11.121 16.9976 13.1545 16.154 14.6542 14.6542C16.154 13.1544 16.9976 11.121 17 9C17 7.41775 16.5308 5.87103 15.6518 4.55544C14.7727 3.23984 13.5233 2.21447 12.0615 1.60896C10.5997 1.00346 8.99113 0.845036 7.43928 1.15372C5.88743 1.4624 4.46197 2.22433 3.34315 3.34315C2.22433 4.46197 1.4624 5.88743 1.15372 7.43928C0.84504 8.99113 1.00347 10.5997 1.60897 12.0615C2.21447 13.5233 3.23985 14.7727 4.55544 15.6518ZM9 6.5C9.55229 6.5 10 6.05228 10 5.5C10 4.94772 9.55229 4.5 9 4.5C8.44772 4.5 8 4.94772 8 5.5C8 6.05228 8.44772 6.5 9 6.5ZM9.5 8.5V7.5H7.5V8.5H8.5V12.5H7.5V13.5H10.5V12.5H9.5V8.5Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Info_icon.9e3f2f421838eebc86b0b31aa39f7210.svg";